import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FiShoppingCart } from 'react-icons/fi'
import { BsCheck, BsStarFill } from 'react-icons/bs'
import CartContext from '../../context/CartContext'
import './index.css'

const ProductCard = props => {
  const { productData, viewMode = 'grid' } = props
  const { title, brand, imageUrl, rating, price, id } = productData
  const [isAdding, setIsAdding] = useState(false)
  const [isAdded, setIsAdded] = useState(false)

  return (
    <CartContext.Consumer>
      {value => {
        const { addCartItem } = value

        const handleQuickAdd = async (e) => {
          e.preventDefault()
          e.stopPropagation()
          setIsAdding(true)
          try {
            await addCartItem({ ...productData, quantity: 1 })
            setIsAdded(true)
            setTimeout(() => {
              setIsAdded(false)
              setIsAdding(false)
            }, 1500)
          } catch (err) {
            setIsAdding(false)
          }
        }

        return (
          <li className={`product-item ${viewMode}`}>
            <Link to={`/products/${id}`} className="link-item">
              <div className="product-img-wrapper">
                <img src={imageUrl || productData.image_url} alt="product" className="thumbnail" loading="lazy" />
              </div>
              <div className="product-info-wrapper">
                <h1 className="title" title={title}>{title}</h1>
                <p className="brand">{brand?.toUpperCase()}</p>
                <div className="product-actions">
                  <div className="product-details">
                    <p className="price">₹{price}</p>
                    <div className="rating-container">
                      <BsStarFill color="#f59e0b" size={12}/>
                      <p className="rating">{rating}</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className={`card-add-btn ${isAdded ? 'added' : ''}`}
                    onClick={handleQuickAdd}
                    disabled={isAdding || isAdded}
                  >
                    {isAdded ? (
                      <>
                        <BsCheck size={16} /> Added
                      </>
                    ) : (
                      <>
                        <FiShoppingCart size={14} /> Add to Cart
                      </>
                    )}
                  </button>
                </div>
              </div>
            </Link>
          </li>
        )
      }}
    </CartContext.Consumer>
  )
}
export default ProductCard
